module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Code/Github-8a28999870caa035b031b40115e96d06.svg";